import React from "react";
import { Button } from "@/components/design-system/Button/Button";
import { trackCalendlyClick } from "@/utils/analytics";
import { StatCard } from "@/components/design-system/StatCard/StatCard";
import { stats } from "./EmployerStatsSection.data";
import { FEATURE_FLAGS } from "@/data/featureFlags";

type EmployerStatsSectionProps = {
  onOpenCalc: () => void;
};

export const EmployerStatsSection: React.FC<EmployerStatsSectionProps> = ({
  onOpenCalc,
}) => {
  const handleOpenCalc = () => {
    trackCalendlyClick("emp_stats");
    onOpenCalc();
  };

  return (
    <section id="emp-stats" className="bg-primary-700 w-full">
      <div className="mx-auto max-w-360 px-5 py-16 md:px-8 md:py-24 lg:px-16">
        <div className="mb-12 flex flex-col items-center gap-6 text-center md:mb-16 xl:mx-auto xl:max-w-282">
          <p className="caption-bold uppercase text-white">
            Why It Matters
          </p>
          <h2 className="headline-d-extrabold md:headline-c-extrabold text-white">
            The real cost of financial stress.
          </h2>
          <p className="body-a-regular md:subtitle-b-regular max-w-282 text-white">
            One in three of your employees is losing sleep over money. That
            stress doesn't stay at home — it's a real cost to your business
            every day.
          </p>
        </div>

        <div className="mb-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4 xl:mx-auto xl:max-w-282">
          {stats.map((stat) => (
            <StatCard
              key={stat.value}
              stat={stat.value}
              description={stat.description}
              className="shadow-[0px_0px_30px_var(--color-primary-900)]"
              statClassName="bg-accent-blue-bg text-accent-blue"
            />
          ))}
        </div>

        <div className={`flex justify-center${!FEATURE_FLAGS.showCalculators ? " hidden" : ""}`}>
          <Button
            variant="outline"
            size="lg"
            onClick={handleOpenCalc}
            className="rounded-[10px] inline-flex h-12 items-center justify-center bg-transparent px-6 text-lg font-normal text-white transition border border-white hover:bg-white/10 focus:ring-0 focus:ring-offset-0"
          >
            Calculate ROI
          </Button>
        </div>
      </div>
    </section>
  );
};
